module.exports = __webpack_public_path__ + "static/media/BR1.9f0485ed.webp";